/********************************************************************************
 * Copyright (c) 2021, 2023 BMW Group AG
 * Copyright (c) 2021, 2023 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Apache License, Version 2.0 which is available at
 * https://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ********************************************************************************/

import { FunctionComponent } from 'react'
import { Button } from '../../Button'
import { Dialog } from '../../Dialog'
import { DialogActions } from '../../Dialog/DialogActions'
import { DialogContent } from '../../Dialog/DialogContent'
import { DialogHeader } from '../../Dialog/DialogHeader'
import { deleteConfirmOverlayTranslation } from '../types'

export interface DeleteConfirmOverlayProps {
  deleteOverlay: boolean
  onCallback: (closeOverlay: boolean) => void
  deleteOverlayTranslation?: deleteConfirmOverlayTranslation
}

export const DeleteConfirmOverlay: FunctionComponent<
  DeleteConfirmOverlayProps
> = ({ onCallback, deleteOverlay = false, deleteOverlayTranslation }) => {
  return (
    <Dialog
      open={deleteOverlay}
      additionalModalRootStyles={{
        width: '45%',
      }}
    >
      <DialogHeader
        {...{
          title: deleteOverlayTranslation?.title || '',
          closeWithIcon: false,
        }}
      />
      <DialogContent
        sx={{
          padding: '0px 120px 40px 120px',
        }}
      >
        {deleteOverlayTranslation?.content}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            minWidth: '100px',
          }}
          variant="outlined"
          onClick={() => onCallback(false)}
        >
          {deleteOverlayTranslation?.action_no}
        </Button>
        <Button
          sx={{
            mr: '2',
            minWidth: '100px',
          }}
          variant="contained"
          onClick={() => onCallback(true)}
        >
          {deleteOverlayTranslation?.action_yes}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
